import { observer } from "mobx-react";
import { FormFieldLine } from "../../../../components/form-field-line/form-field-line";
import { NOTE_TYPE, Note } from "../../../../components/note/note";
import { ShippingInstructionsChangeTrigger } from "../../return-method-types";
import ReturnMethodStore from "../../stores/return-method-store";
import useDashboardTranslation from "../../../../dashboard-translation/hooks/dashboard-translation-hook";
    
interface IProps {
    returnMethod?: ReturnMethodStore,
    trigger: ShippingInstructionsChangeTrigger
}

export const InstrucionsWarningFieldLine: React.FC<IProps> = observer(({ returnMethod, trigger }) => {
    if (!returnMethod) {
        return null;
    }

    const { getTranslation } = useDashboardTranslation();

    const instructionsWarning = returnMethod.getInstructionsChangedNote(trigger, getTranslation);
    if (!instructionsWarning) {
        return null;
    }

    return (
        <FormFieldLine label="">
            <Note type={NOTE_TYPE.WARNING} body={instructionsWarning} />
        </FormFieldLine>
    );
});

